import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import * as theme from '../../../theme';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import StateSelect from '../../../components/StateSelect';

export default function PersonalBusinessInfo({ formData, handleChange, handleDateChange, handlePhoneChange, handleStateChange }) {
  return (
    <Box sx={{ ...theme.FullForm.form, gap: 4 }}>
      <TextField
        label="First Name"
        name="firstName"
        value={formData.firstName}
        onChange={handleChange}
        variant="filled"
        required
      />
      <TextField
        label="Last Name"
        name="lastName"
        value={formData.lastName}
        onChange={handleChange}
        variant="filled"
        required
      />
      <TextField
        label="Phone"
        name="phone"
        value={formData.phone}
        onChange={handlePhoneChange}
        slotProps={{ htmlInput: { inputMode: 'numeric', maxLength: 12 } }}
        variant="filled"
        required
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          label="Date of Birth"
          value={formData.dob}
          onChange={handleDateChange}
          maxDate={dayjs()}
          openTo="year"
          views={['year', 'month', 'day']}
          slotProps={{ textField: { variant: "filled" } }}
        />
      </LocalizationProvider>
      <TextField
        label="Business Name (Optional)"
        name="businessName"
        value={formData.businessName}
        onChange={handleChange}
        variant="filled"
      />
      <TextField
        label="Mailing Address"
        name="street"
        value={formData.street}
        onChange={handleChange}
        variant="filled"
        required
      />
      <TextField
        label="Address Line 2"
        name="address2"
        value={formData.address2}
        onChange={handleChange}
        variant="filled"
      />
      <TextField
        label="City"
        name="city"
        value={formData.city}
        onChange={handleChange}
        variant="filled"
        required
      />
      <Box sx={{ display: "flex", width: '100%', gap: 2 }}>
        <StateSelect 
          value={formData.state} 
          onChange={handleStateChange}
          sx={{ flex: 1 }}
        />
        <TextField
          label="Zip Code"
          name="zip"
          value={formData.zip}
          onChange={handleChange}
          variant="filled"
          required
          sx={{ flex: 1 }}
        />
      </Box>
    </Box>
  );
}